import { Navigate } from "react-router-dom";

// La landing y el acceso participante se fusionaron en una sola pantalla limpia
// (ver ParticipantLogin.js) para que el participante llegue directo al formulario,
// sin una pantalla intermedia de "elegir rol" que compita visualmente.
export default function LandingPage() {
  return <Navigate to="/login" replace />;
}
